import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punepilgrimagetaxiservice() {



  const cardData = {
"keyword": "Pune Pilgrimage Taxi Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Pilgrimage Taxi Service for devotees and spiritual travelers who want a safe, peaceful, and well-organized journey to Maharashtra’s most sacred destinations. Whether you are planning temple darshan, Ashtavinayak yatra, Jyotirlinga visit, family pilgrimage, senior citizen tour, or multi-day religious travel, our taxi service ensures a smooth and stress-free experience. With experienced drivers who are familiar with temple routes, highways, and rural pilgrimage circuits, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for individuals, families, and large groups. With flexible one-way, round-trip, and custom pilgrimage packages, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and spiritually fulfilling journey across Maharashtra’s most revered temples.",

"topPlaces": [
  {
    "title": "Ashtavinayak Temples Circuit",
    "description":
      "The Ashtavinayak circuit includes eight sacred Ganesha temples such as Morgaon, Siddhatek, Pali, Mahad, Theur, Lenyadri, Ozar, and Ranjangaon. It is one of the most important pilgrimage routes for devotees starting from Pune, offering a complete spiritual experience across Maharashtra."
  },
  {
    "title": "Bhimashankar Jyotirlinga",
    "description":
      "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlinga temples of Lord Shiva, located in the Sahyadri hills. Surrounded by dense forests and wildlife, it is a major spiritual and nature pilgrimage destination near Pune."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description":
      "Shirdi Sai Baba Temple is one of India’s most visited pilgrimage sites dedicated to Sai Baba. Devotees from Pune frequently travel here for darshan, aarti, and spiritual blessings in a peaceful devotional atmosphere."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description":
      "Shani Shingnapur Temple is famous for its open-air shrine of Lord Shani and unique village traditions. It is a major spiritual destination often included in Pune pilgrimage taxi tours."
  },
  {
    "title": "Tuljapur Bhavani Temple",
    "description":
      "Tuljapur Bhavani Temple is one of the most powerful Shakti Peethas in Maharashtra dedicated to Goddess Bhavani. It holds great historical and spiritual importance, especially linked with Chhatrapati Shivaji Maharaj."
  },
  {
    "title": "Pandharpur Vitthal Rukmini Temple",
    "description":
      "Pandharpur is a sacred pilgrimage town on the banks of the Chandrabhaga River dedicated to Lord Vitthal and Rukmini. It is one of the most important Vaishnavite pilgrimage destinations in Maharashtra."
  },
  {
    "title": "Akkalkot Swami Samarth Temple",
    "description":
      "Akkalkot is a major spiritual destination dedicated to Swami Samarth Maharaj. Devotees visit the temple and samadhi math seeking blessings, peace, and spiritual guidance."
  },
  {
    "title": "Jejuri Khandoba Temple",
    "description":
      "Jejuri Khandoba Temple is a famous hilltop temple dedicated to Lord Khandoba, known for its turmeric-filled rituals and vibrant devotional atmosphere, attracting thousands of pilgrims from Pune."
  },
  {
    "title": "Ganpatipule Coastal Temple",
    "description":
      "Ganpatipule is a unique coastal pilgrimage destination featuring a Swayambhu Ganpati temple located beside a pristine beach. It offers a blend of spirituality and natural beauty."
  },
  {
    "title": "Maharashtra Pilgrimage Route Network",
    "description":
      "The Pune pilgrimage taxi routes connect major spiritual destinations across Maharashtra, including Jyotirlingas, Shakti Peethas, Ashtavinayak temples, and coastal temples, offering a complete and comfortable devotional travel experience."
  }
],



services: [
  {
    name: "Pune Pilgrimage Taxi",
    description: "Pune pilgrimage taxi service provides reliable transportation for devotees and travelers visiting famous temples and spiritual destinations around Pune and Maharashtra. Comfortable vehicles with experienced drivers ensure smooth travel for families, pilgrims, tourists, and senior citizens. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different pilgrimage travel requirements. Flexible booking options allow convenient pilgrimage taxi reservations."
  },
  {
    name: "Pune Religious Cab Service",
    description: "Pune religious cab service offers dependable transportation for spiritual tours and temple visits with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for religious tourism, family darshan trips, and group pilgrimage tours. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient religious cab reservations."
  },
  {
    name: "Pune Temple Yatra Taxi",
    description: "Pune temple yatra taxi service provides comfortable transportation for devotees visiting temples, pilgrimage centers, and sacred attractions around Pune. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys across temple routes. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day and multi-day pilgrimage travel requirements. Flexible booking options allow convenient temple yatra taxi reservations."
  },
  {
    name: "Pune Spiritual Cab Pune",
    description: "Pune spiritual cab Pune service offers reliable transportation with comfortable vehicles and professional drivers for spiritual journeys and religious sightseeing around Pune. Vehicles provide smooth city and highway travel suitable for temple tourism, family darshan trips, and cultural visits. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy spiritual cab reservations."
  },
  {
    name: "Pune Pilgrimage Tour Cab",
    description: "Pune pilgrimage tour cab service provides dependable transportation solutions for passengers traveling to temples and sacred destinations from Pune. Vehicles are suitable for city and long-distance temple travel ensuring safe and smooth journeys for individuals, families, and groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for spiritual travel, darshan tours, and pilgrimage visits. Flexible booking options allow convenient pilgrimage tour cab reservations."
  },
  {
    name: "Best Pune Pilgrimage Taxi",
    description: "Best Pune pilgrimage taxi service provides transparent and reliable transportation for devotees planning comfortable temple tours and spiritual journeys from Pune. Travelers can enjoy peaceful journeys with experienced drivers familiar with temple routes and pilgrimage destinations. Comfortable vehicles ensure smooth travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient pilgrimage taxi reservations."
  },
  {
    name: "Cheap Pune Pilgrimage Cab",
    description: "Cheap Pune pilgrimage cab service provides economical and comfortable transportation for families and devotees planning temple tours from Pune. Vehicles ensure smooth city and highway travel suitable for pilgrimage tourism, family darshan trips, and group travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow affordable pilgrimage cab reservations."
  },
  {
    name: "SUV Pune Pilgrimage Taxi",
    description: "SUV Pune pilgrimage taxi service offers spacious transportation for families and groups planning temple visits and spiritual tours from Pune. SUV vehicles provide comfortable seating, smooth ride quality, and luggage space suitable for long-distance religious travel. Professional drivers ensure safe and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV pilgrimage taxi reservations."
  },
  {
    name: "Innova Pune Pilgrimage Cab",
    description: "Innova Pune pilgrimage cab service allows passengers to reserve premium SUV transportation for comfortable temple tours and pilgrimage journeys from Pune. Innova vehicles provide spacious seating and smooth highway travel suitable for families, senior citizens, and group darshan travel. Professional drivers ensure safe driving and punctual pickup services throughout the temple tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Innova pilgrimage cab reservations."
  },
  {
    name: "Sedan Pune Pilgrimage Taxi",
    description: "Sedan Pune pilgrimage taxi service provides affordable transportation for devotees planning spiritual journeys and temple visits from Pune. Sedan vehicles ensure reliable city and highway travel suitable for spiritual tourism, pilgrimage tours, and family darshan trips. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient sedan pilgrimage taxi reservations."
  },
  {
    name: "Pune Religious Travel Cab",
    description: "Pune religious travel cab service offers premium transportation with comfortable vehicles and professional chauffeurs for religious tours and pilgrimage travel from Pune. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for spiritual tourism and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient religious travel cab reservations."
  },
  {
    name: "Pune Holy Places Cab",
    description: "Pune holy places cab service provides comfortable transportation for devotees planning same-day temple darshan and religious sightseeing tours from Pune. Vehicles ensure smooth and safe city and highway travel suitable for spiritual tourism, family travel, and temple visits. Professional chauffeurs ensure timely pickup and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient holy places cab reservations."
  },
  {
    name: "Pune Spiritual Journey Taxi",
    description: "Pune spiritual journey taxi service provides dependable transportation for passengers planning spiritual and temple tours from Pune. Comfortable vehicles ensure smooth travel suitable for pilgrimage tourism, educational tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient spiritual journey taxi reservations."
  },
  {
    name: "Pune Temple Pilgrimage Cab",
    description: "Pune temple pilgrimage cab service provides reliable transportation for travelers and devotees planning temple tours and spiritual journeys around Pune and nearby pilgrimage destinations. Comfortable vehicles ensure smooth and safe travel suitable for tourists, families, senior citizens, and pilgrimage groups. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient temple pilgrimage cab reservations."
  },
  {
    name: "Pune Faith Travel Cab",
    description: "Pune faith travel cab service offers comfortable transportation for passengers planning religious tours and spiritual journeys from Pune to major pilgrimage destinations. Vehicles ensure reliable local and highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Ideal for spiritual tourism, temple darshan, and family pilgrimage travel. Flexible booking options allow convenient faith travel cab reservations."
  }
],

tableData: [
  ["Pune Pilgrimage Taxi", "Pune Religious Cab Service"],
  ["Pune Temple Yatra Taxi", "Pune Spiritual Cab Pune"],
  ["Pune Pilgrimage Tour Cab", "Best Pune Pilgrimage Taxi"],
  ["Cheap Pune Pilgrimage Cab", "SUV Pune Pilgrimage Taxi"],
  ["Innova Pune Pilgrimage Cab", "Sedan Pune Pilgrimage Taxi"],
  ["Pune Religious Travel Cab", "Pune Holy Places Cab"],
  ["Pune Spiritual Journey Taxi", "Pune Temple Pilgrimage Cab"],
  ["Pune Faith Travel Cab", "Pune Pilgrimage Taxi"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Pilgrimage Taxi Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Pilgrimage taxi service with professional drivers, comfortable vehicles, and punctual pickup for smooth and peaceful religious travel."
      },
      {
        WhyChooseheading: "Affordable Pilgrimage Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Pilgrimage taxi pricing with transparent fare details and no hidden charges. Customers receive complete pilgrimage package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Pilgrimage Cab Availability",
        WhyChoosedescription: "Our Pune Pilgrimage taxi service operates 24 hours a day for temple visits, religious tours, family pilgrimages, darshan trips, and customized spiritual travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during pilgrimage journeys."
      },
      {
        WhyChooseheading: "Customized Pilgrimage Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Shirdi tours, Ashtavinayak Darshan, Pandharpur trips, Tuljapur tours, Jyotirlinga tours, and customized religious travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for pilgrims, families, senior citizens, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Religious Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with pilgrimage routes across Maharashtra and nearby states, ensuring safe driving, smooth travel, and timely darshan for every spiritual journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Pilgrimage taxi service?", answer: "Pune Pilgrimage taxi service provides comfortable taxi transportation for visiting famous temples, jyotirlingas, and religious destinations from Pune." },
    { question: "Is Pune Pilgrimage taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Pilgrimage taxi service." },
    { question: "Which vehicles are available for pilgrimage tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized pilgrimage tour packages?", answer: "Yes, customers can book customized pilgrimage and temple tour packages according to their travel requirements." },
    { question: "Which religious destinations are covered in Pune Pilgrimage tours?", answer: "Shivai Travels covers destinations like Shirdi, Ashtavinayak, Tuljapur, Pandharpur, Bhimashankar, Trimbakeshwar, and Jyotirlinga tours." },
    { question: "Are all pilgrimage taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable spiritual travel." },
    { question: "Can I book Pune Pilgrimage taxi service online?", answer: "Yes, customers can easily book Pune Pilgrimage taxi service online or through phone booking." },
    { question: "Do you provide taxis for family and group pilgrimage tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group pilgrimage travel." },
    { question: "Are Pune Pilgrimage taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Pilgrimage taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Mahesh Kulkarni",
      feedback:
        "Booked Pune Pilgrimage taxi service with Shivai Travels. Comfortable vehicle, smooth spiritual journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Anjali Patil",
      feedback:
        "Excellent Pune Pilgrimage taxi service. Affordable pricing, clean cab, and wonderful religious travel experience.",
      rating: 5
    }
  ];











  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Pilgrimage Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-pilgrimage-taxi.jpg",
  "description": "Book Pune Pilgrimage taxi service for safe and comfortable religious travel. Shivai Travels offers customized temple yatra and spiritual tour packages with sedan, SUV, Innova, and luxury cab options available 24x7 for holy places and pilgrimage circuits around Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-pilgrimage-taxi-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune Pilgrimage Taxi Service | Religious Travel Cab | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Pilgrimage taxi service for temple visits and spiritual journeys. Affordable religious travel packages with sedan, SUV, Innova, and luxury cabs available 24x7 for pilgrimage tours and holy places."
  />

  <meta
    name="keywords"
    content="pune pilgrimage taxi, pune religious cab service, pune temple yatra taxi, pune spiritual cab pune, pune pilgrimage tour cab, best pune pilgrimage taxi, cheap pune pilgrimage cab, suv pune pilgrimage taxi, innova pune pilgrimage cab, sedan pune pilgrimage taxi, pune religious travel cab, pune holy places cab, pune spiritual journey taxi, pune temple pilgrimage cab, pune faith travel cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punepilgrimagetaxiservice;